import React from 'react';
import ReactDOM from 'react-dom';
import IframeAdBase from './ad/IframeAdBase';
import IframeCommerceUnit from './ad/IframeCommerceUnit';
import _ from 'lodash';
import ClientAnalytics from './analytics/ClientAnalytics';
import {setupClientErrorReporting, captureMessage} from './utils/SentryUtils';
import {restoreScriptTags} from './utils/RenderUtils';
import {getCampaignRenderers} from './augmentation/parseConfigs';
import {getFrameId, fetchAdIframeUrl, getAdHostingWindow, readLastMountedRendererToken, saveLastMountedRendererToken, getPublisherSpecificIframeUrl, interpolateIframeCode} from './ad/utils';
import {arrayRemoveItem} from './common/ImmutableUtils';
import {getPublisherByUrl} from './utils/PublisherUtils';
import {injectHtml, getTopWindowUrl} from './utils/DomUtils';
import FrameMessages from './const/FrameMessages';
// debug
// import settings from '../config/settings';
// import urlParse from 'url-parse';

if (__PRODCLIENT__) {
  setupClientErrorReporting();
}

// Export React so the dev tools can find it
if (window === window.top) {
  window.React = React;
}

renderAd();


async function renderAd() {
  const state = restoreScriptTags(window.__STATE__);
  const {campaign, useRotatingRenderer, isOuterRequest} = state;
  const renderer = getTargetRenderer(state);
  if (!renderer) return;

  const usesNewAdConfig = !!renderer.adRenderer;

  if (isOuterRequest) {
    // two-level iframes, internally load publisher-specific iframe
    const refererUrl = getTopWindowUrl();
    const publisher = getPublisherByUrl(refererUrl, campaign.campaignSlots);
    const publisherId = _.get(publisher, 'publisherId', null);
    const internalUrl = getPublisherSpecificIframeUrl(renderer.iframeUrl, publisherId);

    // FOR DEBUGGING PURPOSES:
    // const parsed = urlParse(internalUrl);
    // const replacement = urlParse(settings.frontendBaseURL);
    // parsed.set('protocol', replacement.protocol);
    // parsed.set('hostname', replacement.hostname);
    // parsed.set('port', replacement.port);
    // internalUrl = parsed.toString();

    // pre-fetch iframe url status and hide popup in case of error status
    try {
      await fetchAdIframeUrl(internalUrl);
    } catch (e) {
      const frameId = getFrameId(renderer.id, null, campaign.id);
      getAdHostingWindow().postMessage({title: FrameMessages.requestHide, frameId}, '*');
      captureMessage(`Error while loading Ad iframe url: ${internalUrl}`, 'error');
      return;
    }

    const iframeCode = interpolateIframeCode(renderer.iframeCode, internalUrl);
    injectHtml(document.body, iframeCode);
    const iframeElem = document.getElementsByTagName('iframe')[0];
    iframeElem.classList.add('vup-inner-ad-iframe');
    if (useRotatingRenderer && renderer) {
      saveLastMountedRendererToken(campaign.id, renderer.iframeToken);
    }
    return;
  }

  // normal flow (render the Ad iframe)
  const popupRoot = document.getElementById('vup-ad-component');
  if (popupRoot) {
    ClientAnalytics.initialize();
    if (usesNewAdConfig) {
      ReactDOM.hydrate(<IframeCommerceUnit {...state}/>, popupRoot);
    } else {
      ReactDOM.hydrate(<IframeAdBase {...state}/>, popupRoot);
    }
  }
}

// function checkInnerIframeStatus(campaign, renderer) {
//   const frameId = getFrameId(renderer.id, null, campaign.id);
//   getAdHostingWindow().postMessage({title: FrameMessages.requestHide, frameId}, '*');
// }

function getTargetRenderer(state) {
  const {campaign, useRotatingRenderer} = state;
  if (useRotatingRenderer) {
    const previouslyMountedRendererToken = readLastMountedRendererToken(campaign.id);
    const renderers = getCampaignRenderers(campaign);
    const rendererTokens = renderers.map(r => r.iframeToken);
    const newIndex = getRandomOtherIndex(rendererTokens, previouslyMountedRendererToken);
    return renderers[newIndex];
  }
  return state.renderer;
}

function getRandomOtherIndex(arr, lastValue) {
  if (arr.length <= 1) {
    return 0;
  }
  const otherValues = arrayRemoveItem(arr, lastValue);
  const randomOtherValue = otherValues[Math.floor(Math.random() * otherValues.length)];
  return arr.indexOf(randomOtherValue);
}
